import { getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyTerms } from '../../actions/policy/reducePolicyTerms';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicyTermsSaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicyTerms', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyTerm/terms/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        if (response.ok) {
            yield put(reducePolicyTerms(result.terms || []));
        }
    } catch (error) {
        console.log('Error while calling Get Policy Terms API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getPolicyTerms', value: false }));
    }
}
